import { render } from "./AdditionalInformation.vue?vue&type=template&id=44671549&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=44671549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44671549"]])

export default __exports__